// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"419cf0aa","977":"85c9eee6"}[chunkId] + ".chunk.js";
};